import React from "react";
import "./Extra.css";
import logo from "../../components/logo.png";
import rob from "../../components/rob.jpeg";
import traquila from "../../components/traquila.jpeg";

function index() {
  return (
    <div className="extra">
      <div className="extra_logo">
        <img src={logo} alt="" />
      </div>
      <h1>Carolina Sauce Methods</h1>
      <h2>Additional Resources</h2>
      <div className="packages">
        <div className="package">
          <p>
            PLEASE ACKNOWLEDGE: I DO NOT OWN THIS CHANNEL. THIS IS ONLY A
            REFERRAL. <br /> 🚨 PLEASE TURN ON NOTIFICATIONS FOR ALL VENDORS TO
            REDUCE TRADELINE SCARCITY
          </p>
          <p>
            Please use this link if you want to make money referring others to
            these channels: <br />
            <a href="https://www.fanbasis.com/affiliate-signup/Antoniobibbs_">
              https://www.fanbasis.com/affiliate-signup/Antoniobibbs_
            </a>
          </p>
          <p>
            🏆 FIRST TRADELINE VENDOR: This is the current Tradeline list ORDER
            LINES HERE. NEW LINES ARE UPDATED DAILY. PLEASE USE ALL VENDORS:{" "}
            <br />
            <a href="https://form.jotform.com/240216988519062">
              https://form.jotform.com/240216988519062
            </a>
          </p>
          <p>
            Additional resources:{" "}
            <a href="https://linktr.ee/QND99">https://linktr.ee/QND99</a>
          </p>
          <p>
            Main Channel:{" "}
            <a href="https://t.me/+QcRyjDS12CozNGQx">
              https://t.me/+QcRyjDS12CozNGQx
            </a>
          </p>
          <p>
            🏆 SECONDARY TRADELINE VENDOR: Main channel <br />
            <a href="https://t.me/TheBestTradeLines">
              https://t.me/TheBestTradeLines
            </a>
          </p>
          <p>
            Order Form:{" "}
            <a href="https://form.jotform.com/240067579543059">
              https://form.jotform.com/240067579543059
            </a>
          </p>
          <p>
            🏆 THIRD TRADELINE VENDOR:{" "}
            <a href="https://hart2hartent.com/available-tradelines/">
              https://hart2hartent.com/available-tradelines/
            </a>
          </p>
          <p>
            🏆 FOURTH TRADELINE VENDOR:{" "}
            <a href="https://t.me/approvedbymarkebaby">
              https://t.me/approvedbymarkebaby
            </a>
          </p>
          <p>
            🏆 FIFTH TRADELINE VENDOR:{" "}
            <a href="https://t.me/SlimsMarketPlace2024">
              https://t.me/SlimsMarketPlace2024
            </a>
          </p>
        </div>
        <div className="package">
          <h2 style={{ textTransform: "uppercase" }}>
            Credit card, food and travel vendors
          </h2>
          <a href="https://blackpass.biz/">https://blackpass.biz/</a>
          <br />
          <a href="https://juicy.fo">https://juicy.fo</a>
          <br />
          <a href="https://imperium.fo/">https://imperium.fo/</a>
          <br />
          <a href="https://thesaucemarket.atshop.io/">
            https://thesaucemarket.atshop.io/
          </a>
          <br />
          <a href="https://altsworld.atshop.io/order/djTGLXbL2TELHPRm3">
            https://altsworld.atshop.io/order/djTGLXbL2TELHPRm3
          </a>
          <br />
          <a href="https://punchmade.atshop.io/">
            https://punchmade.atshop.io/
          </a>
          <br />
          <a href="https://yalelodge.io">https://yalelodge.io</a>
          <br />
          <a href="http://Fernandogoods.at/">http://Fernandogoods.at/</a>
          <br />
          <a href="http://t.me/SHADYWAY">http://t.me/SHADYWAY</a>
          <br />
          <a href="https://t.me/johnwickbanks">https://t.me/johnwickbanks</a>
          <br />
          <a href="https://realandrare.cc/login">
            https://realandrare.cc/login
          </a>
          <br />
          <a href="https://ultimateshop.mp/">https://ultimateshop.mp/</a>
          <br />
          <a href="https://vclubshop.gd">https://vclubshop.gd</a>
          <br />
          <div className="more">
            <div className="more_img">
              <img src={traquila} alt="" />
            </div>
            <p>+1 (404) 840-1742 -Traquila (ATL only) -Apartment Hookups</p>
          </div>
          <div className="more">
            <div className="more_img">
              <img src={rob} alt="" />
            </div>
          <p>+1 (404) 610-0044 -Rob (Any state) -Travel Hookups</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default index;
